import { render, staticRenderFns } from "./DynamicRegister.vue?vue&type=template&id=2dac46e8&scoped=true"
import script from "./DynamicRegister.vue?vue&type=script&lang=js"
export * from "./DynamicRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dac46e8",
  null
  
)

export default component.exports